// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KVFx","col":"styles_col__3HHIU"};